// import React from "react";
import { Container, Row, Col } from "react-bootstrap"
import ProjectCard from "./ProjectCards"
import Particle from "../Particle"
// import MERN from "../../Assets/Projects/MERN.png";
import Grilli from "../../Assets/Projects/Grilli.png"
import Notekeeper from "../../Assets/Projects/Notekeeper.png"
// import Game from "../../Assets/Projects/BubbleGame.png";
// import School from "../../Assets/Projects/EducationWebsite.png"
import GitFinder from "../../Assets/Projects/GitFinder.png"
// import Care from "../../Assets/Projects/CarePulse-removebg-preview.png";
import Care from "../../Assets/Projects/CollaboratorEditor-removebg-preview.png"
// import MERN from "../../Assets/Projects/MERNEats.png"
import Pictionary from "../../Assets/Projects/pictionary.png"
import Easymart from "../../Assets/Projects/easymart.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Pictionary}
              isBlog={false}
              title="Pictionary"
              description="Experience real-time multiplayer drawing and guessing with this skribbl.io-inspired Pictionary game. Built on a MERN stack with Socket.IO, it features JWT authentication for both HTTP and WebSocket connections, ensuring secure access throughout. Players create or join rooms, take turns drawing on a shared canvas synced across all devices using normalized coordinates, and compete with a time-and-order-based scoring system. Anti-cheat logic keeps the word secret from guessers while the drawer gets live tools — colors, brush sizes, and eraser. Persistent leaderboards track all-time scores via MongoDB, and the Neo-Brutalist UI makes every round visually bold and fast-paced."
              // ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="https://pictionary.sultandev.xyz/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Easymart}
              isBlog={false}
              title="Easy Mart"
              description="Discover a seamless grocery shopping experience with our responsive Vanilla JS-powered platform. Built with Tailwind CSS and Vite, the app delivers a fast, lightweight interface with smooth transitions and mobile-optimized views. Users can browse products by category, search items instantly, and add favorites to a dynamic cart with real-time price updates. Intuitive filtering helps customers find groceries quickly, while a clean checkout flow keeps the ordering process simple. From product discovery to cart management, this app streamlines the grocery delivery journey—effortlessly quick, anytime, anywhere."
              // ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://easymart.sultandev.xyz/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Notekeeper}
              isBlog={false}
              title="Notekeeper"
              description="NoteKeeper, a user-friendly web application designed to simplify your note-keeping and organization needs. Create Notebooks: Easily categorize your notes for work, personal use, or any other purpose, keeping your thoughts organized. Manage Notes: Within each notebook, you can create, edit, update, and delete notes, making it a breeze to keep your ideas in check.Secure Local Storage: Your data is stored in your browser's local storage, ensuring that you can access your notes anytime, without the need for accounts or syncing."
              // ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://notekeeper-by-mohd-sultan.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Care}
              isBlog={false}
              title="Healthcare"
              description="Streamline healthcare access with our fully responsive, feature-rich appointment management system. Patients can easily register, create profiles, and book multiple appointments with doctors. Admins manage the scheduling process with tools to view, confirm, or cancel appointments as needed. SMS notifications ensure patients stay informed with real-time confirmations. Secure file uploads are handled via Appwrite, while Sentry integration tracks performance and errors for optimal reliability. With a clean architecture and focus on reusability, this app delivers a smooth and scalable experience—anytime, on any device."
              // ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="https://bubble-game-by-mohd-sultan.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Grilli}
              isBlog={false}
              title="Grilli"
              description="Experience the essence of fine dining through this elegant and responsive restaurant website built with HTML, CSS, and minimal JavaScript. Designed for a smooth user experience across all devices, the site features visually engaging sections like hero banners, menu highlights, chef specials, testimonials, and a reservation form. Smooth scrolling, interactive buttons, and subtle animations enhance usability, while a well-structured layout ensures intuitive navigation. Perfectly suited for showcasing a modern dining experience, the Grilli website balances aesthetic design with clear content flow—creating a digital presence that’s both appealing and functional."
              // ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              demoLink="https://new-education-website-by-sultan.netlify.app/"
              // <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={GitFinder}
              isBlog={false}
              title="GitFinder"
              description="GitFinder is a sleek, responsive web app that lets users search for GitHub profiles and view key information in real-time. Built using HTML, CSS, and JavaScript, it leverages the GitHub API to fetch and display data like user bio, repositories, follower count, and more. The interface is clean and user-friendly, with dynamic input handling and instant feedback. Designed for speed and simplicity, GitFinder offers a smooth browsing experience across all devices—making it a handy tool for exploring developer profiles with ease."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              demoLink="https://gitfinder-by-mohd-sultan.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default Projects
